import {
  RootFactory,
  ServicesFactory,
  TestimonialsFactory,
  ContactFactory,
  PortfolioFactory,
  PortfolioFiltersFactory,
} from '../factories';

export const knightBuilder = () => {
  return {
    buildTemplate: (website) => ({
      theme: "knight",
      ...RootFactory.getKnight(website),
      services: ServicesFactory.getBase(website),
      testimonials: TestimonialsFactory.getBase(website),
      contact: ContactFactory.getBase(website),
      portfolio: PortfolioFactory.getBase(website),
      portfolioFilters: PortfolioFiltersFactory.getBase(website),
    })
  };
};



// WEBPACK FOOTER //
// ./src/store/generators/websiteTemplates/builders/KnightBuilder.js